import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'intersection-observer';
